import { Component, OnInit, Input } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { invoice } from "src/app/models/invoice";
@Component({
    selector: 'app-invoicedetails',
    templateUrl: './invoicedetails.component.html',
    styleUrls: ['./invoicedetails.component.css'
        , '../../../../../assets/css/custom-egd.css'
    ]
})
@TraceClassDecorator()
export class InvoicedetailsComponent implements OnInit {
    @Input() data: any;
    @Input() dataId: string;

    invoice_data: invoice = new invoice();

    constructor() { }

    ngOnInit(): void {
        this.invoice_data.invoice_id = this.data.p_invoice.invoice_id;
        this.invoice_data.invoice_to = this.data.p_accounts.first_name + " " + (this.data.p_accounts.middle_name==null?'':this.data.p_accounts.middle_name) + " " + this.data.p_accounts.last_name;
        this.invoice_data.email = this.data.p_accounts.user_patient.users.e_email;
        this.invoice_data.phone = this.data.p_accounts.primary_contact_number;
        this.invoice_data.location = {
            address: this.data.p_accounts.address_line_1,
            city: this.data.p_accounts.city,
            state: this.data.p_accounts.state_name,
            country: this.data.p_accounts.country.country_name,
            zip: this.data.p_accounts.zip_code,
            final_location: "",
        };
        this.invoice_data.location.final_location = [this.invoice_data.location.address,
        this.invoice_data.location.city,
        this.invoice_data.location.state,
        this.invoice_data.location.zip]
            .filter((ele) => {
                if (ele)
                    return ele;

            }).join(", ");
        this.invoice_data.payment = {
            paid_by: this.data.payment_gateway_type,
            no_card: false,
            card: "",
            card_no: ""
        }
        let i = 0;
        this.invoice_data.transactions = [];
        this.invoice_data.consultation_specialties = "";
        if (this.data.p_consultation) {
            this.invoice_data.consultation_specialties = this.data.p_consultation.specialties.map((ele) => {
                if (ele)
                    return ele.d_specialty_type.specialty_name;
            }).join(", ");
        }
        this.data.basket.item_list.forEach(ele => {
            const tbp = {
                description: ele.name,
                amount: ele.rendered_amount,
                date: this.data.created_at,
                sr_no: ++i
            }
            this.invoice_data.transactions.push(tbp);
        });
        this.invoice_data.total = this.data.basket.rendered_total;
    }

}
